export const updateUsersMeRes = state => state.updateUsersMe;
